export const propertyDeleteHelper = (propertyGuids: string[], currentPropertyId: string | null, targetGuid: string) => {
    //Set the new active current property
    const newCurrentPropertyId =
        currentPropertyId === targetGuid ? propertyGuids.find((pg) => pg !== targetGuid) : currentPropertyId;

    //Delete the property
    const filteredGuids = propertyGuids.filter((pg) => pg !== targetGuid);

    return { newCurrentPropertyId, filteredGuids };
};
